import React from 'react';
import { FormattedMessage, FormattedDate, FormattedTime } from 'react-intl';

import PropTypes from 'prop-types';

const AvailabilityInfo = ({ event }) => {
  const { isUpcoming, startDate, isAvailable, availabilityEnd } = event;

  if (startDate) {
    const Date = <FormattedDate weekday="short" month="short" day="numeric" value={startDate} />;

    const Time = <FormattedTime timeZoneName="short" value={startDate} />;

    if (isUpcoming) {
      return (
        <React.Fragment>
          {Date} - {Time}
        </React.Fragment>
      );
    }
  }

  const availabilityEndTime = <FormattedTime timeZoneName="short" value={availabilityEnd} />;

  const availabilityEndDate = (
    <FormattedDate year="numeric" month="long" day="numeric" value={availabilityEnd} />
  );

  return isAvailable ? (
    <FormattedMessage
      id="livestream-events.event-preview.availability"
      defaultMessage="Available until {availabilityEndTime}, {availabilityEndDate}"
      values={{ availabilityEndTime, availabilityEndDate }}
    />
  ) : (
    <FormattedMessage
      id="livestream-events.event-preview.not-available"
      defaultMessage="This event is no longer available"
    />
  );
};

AvailabilityInfo.propTypes = {
  event: PropTypes.object,
};

export default AvailabilityInfo;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/livestreamEvent/AvailabilityInfo.js